/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Sync/Content/No"
  
}) {
let syncStatusValueData = fromData.useDataValue({ viewPath,
context: 'sync',
path: 'status',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="sync.status"
 text={syncStatusValueData}
/>
{children}
</React.Fragment>)
}